import Cookies from 'js-cookie';

export default {
	state: {
		size: Cookies.get('size') || 'medium',
		requestLoading: 0,
		backendMsgType:'',
		backendMsg:'',
		
		company:null,
		activeNav:null,
	},
	mutations: {
		
		SET_LOADING: (state, status) => {
			// error 的时候直接重置
			if (status === 0) {
				state.requestLoading = 0;
				return;
			}
			state.requestLoading = status ? ++state.requestLoading : --state.requestLoading;
		},
		SET_BACKENDMSGTYPE: (state, msgType) => {
			state.backendMsgType = msgType;
		},
		SET_BACKENDMSG: (state, msg) => {
			state.backendMsg = msg;
		},
		SET_COMPANY: (state, company) => {
			state.company = company;
		},
		SET_ACTIVENAV: (state, activeNav) => {
			state.activeNav = activeNav;
		},
	},
	actions: {
		SetLoading({ commit }, status) {
			commit('SET_LOADING', status);
		},
		SetBackendMsgType({ commit }, msgType) {
			commit('SET_BACKENDMSGTYPE', msgType);
		},
		SetBackendMsg({ commit }, msg) {
			commit('SET_BACKENDMSG', msg);
		},
		SetCompany({ commit }, company) {
			commit('SET_COMPANY', company);
		},
		SetActiveNav({ commit }, activeNav) {
			commit('SET_ACTIVENAV', activeNav);
		},
	},
};